<my-content placeholder="navigation">




    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
    <div class="col-sm-12" style="margin-top: 8px;">
        <div class=" col-sm-12 lefticonD paddingless" style="border:1px solid #ccc; ">
            <label>Manage Escalation Configuration </label>
        </div>
        <div class="col-sm-12"><br></div>
        <!-- <form #SearchNotification="ngForm" [formGroup]="FormSearchNotification" (ngSubmit)="onSearchNotification(SearchNotification.value);"> -->
        <form #SearchNotification="ngForm" [formGroup]="FormSearchEscalation">
            <div class="col-sm-12" style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">

                <div class="col-sm-12">

                    <div class="col-sm-1 text-left height-34">Report Name</div>
                    <div class="col-sm-2"><select class="form-control " formControlName="ReportName" (change)="onReportNameSelect($event.target.value)"><option value="0">[Not Selected] </option> <option *ngFor="let rpt of Report " value="{{rpt.SubDescr}}">{{rpt.MainDescr}}</option></select></div>
                    <div class="col-sm-1" [hidden]="HideContent"><input class="btn btn-primary btn-sm-12 " type="submit" (click)="SaveData()" value="Submit"></div>
                    <div class="col-sm-1" [hidden]="HideContent">
                        <div class="col-sm-12 btn btn-light"><a Title="Print" (click)="print()"><i class="material-icons">
                      print
                      </i><span id="MaterialText">Print</span></a></div>
                    </div>
                    <div class="col-sm-7"></div>
                </div>
            </div>
        </form>
        <br><br>
        <div class="col-sm-12">&nbsp;</div>
        <!-- <div class="col-sm-12" style="margin-top: 8px;" [hidden]="HideContent"> -->
        <form [formGroup]="Form" [hidden]="HideContent">
            <table width="100%" class="LMtable">
                <tr>
                    <th Rowspan="2" width="5%">S.No.</th>
                    <th Rowspan="2" width="8%">Employee Name</th>
                    <th colspan="3" width="29%" style="text-align: center;">
                        <input type="checkbox" class="text-left height-34" (change)="onL1Change($event);" [checked]="L1isSelected" /> Level 1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a class="text-right height-34" routerLink="{{L1MailRoute}}" target="_blank"><i class="material-icons"> email</i><span id="MaterialText">Mail Template</span> </a></th>

                    <th colspan="3" width="29%" style="text-align: center;">
                        <input type="checkbox" class="text-left height-34" (change)="onL2Change($event);" [checked]="L2isSelected" /> Level 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a class="text-right height-34" routerLink="{{L2MailRoute}}" target="_blank"><i class="material-icons"> email</i><span id="MaterialText">Mail Template</span></a></th>
                    <th colspan="3" width="29%" style="text-align: center;">
                        <input type="checkbox" class="text-left height-34" (change)="onL3Change($event);" [checked]="L3isSelected" /> Level 3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a class="text-right height-34" routerLink="{{L3MailRoute}}" target="_blank"><i class="material-icons"> email</i><span id="MaterialText">Mail Template</span></a></th>
                </tr>
                <tr>
                    <th width="5%" style="text-align: center;">Days</th>
                    <th width="5%" style="text-align: center;">Interval</th>
                    <th width="19%" style="text-align: center;">Selected Managers</th>
                    <!-- <th width="30%">Other Email</th> -->
                    <th width="5%" style="text-align: center;">Days</th>
                    <th width="5%" style="text-align: center;">Interval</th>
                    <th width="19%" style="text-align: center;">Selected Managers</th>
                    <!-- <th width="30%">Other Email</th> -->
                    <th width="5%" style="text-align: center;">Days</th>
                    <th width="5%" style="text-align: center;">Interval</th>
                    <th width="19%" style="text-align: center;">Selected Managers</th>
                    <!-- <th width="30%">Other Email</th> -->

                    <!-- <th><input type="checkbox" id="CheckData" (change)="selectAll(this.pageNumber,$event);"></th> -->
                </tr>

                <!-- ============== Show Message / Loading ============== -->
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
                <!-- ==================================================== -->

                <tr *ngFor="let ED of EscalationData; let i=index">
                    <td align="center" width="5%">{{i+1}}
                        <input type="hidden" value={{ED.ID}} [formControlName]="'1|ID|'+ED.ID" />

                    </td>
                    <td width="8%"> {{ED.UserName}}
                        <input type="hidden" value={{this.ReportID}} [formControlName]="'ReportID'" />
                    </td>

                    <td width="5%">
                        <input type="hidden" value={{ED.L1recEnable}} [formControlName]="'1|recEnable|'+ED.ID" />
                        <input type="text" class="form-control" value={{ED.L1Day}} [formControlName]="'1|Day|'+ED.ID" /></td>

                    <td width="5%">
                        <input type="text" class="form-control" [value]="ED.L1interval" [formControlName]="'1|interval|'+ED.ID" />
                    </td>
                    <td width="19%">
                        <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'1|Users|'+ED.ID" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="ED.SelectedL1Email">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                            </ng-template>
                        </ng-select>
                        <input type="hidden" class="form-control" value={{ED.L1Email}} [formControlName]="'1|Email|'+ED.ID" />
                    </td>
                    <!-- <td width="100%"></td> -->




                    <td width="5%">
                        <input type="hidden" value={{ED.L2recEnable}} [formControlName]="'1|recEnable|'+ED.ID">
                        <!-- <input type="hidden" value={{this.ReportID}} [formControlName]="'ReportID|'+ED.ID" /> -->
                        <input type="text" class="form-control" value={{ED.L2Day}} [formControlName]="'2|Day|'+ED.ID" /></td>

                    <td width="5%">
                        <input type="text" class="form-control" [value]="ED.L2interval" [formControlName]="'2|interval|'+ED.ID" />
                    </td>
                    <td width="19%">
                        <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'2|Users|'+ED.ID" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="ED.SelectedL2Email">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                            </ng-template>
                        </ng-select>
                        <input type="hidden" class="form-control" value={{ED.L2Email}} [formControlName]="'2|Email|'+ED.ID" />
                    </td>
                    <!-- <td width="100%"></td> -->


                    <td width="5%">
                        <input type="hidden" value={{ED.L3recEnable}} [formControlName]="'3|recEnable|'+ED.ID">
                        <!-- <input type="hidden" value={{this.ReportID}} [formControlName]="'ReportID|'+ED.ID" /> -->
                        <input type="text" class="form-control" value={{ED.L3Day}} [formControlName]="'3|Day|'+ED.ID" /></td>

                    <td width="5%">
                        <input type="text" class="form-control" [value]="ED.L3interval" [formControlName]="'3|interval|'+ED.ID" />
                    </td>
                    <td width="19%">
                        <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'3|Users|'+ED.ID" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="ED.SelectedL3Email">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                            </ng-template>
                        </ng-select>
                        <input type="hidden" class="form-control" value={{ED.L3Email}} [formControlName]="'3|Email|'+ED.ID" />
                    </td>

                </tr>
            </table>
        </form>
        <br>

        <!-- </div> -->

        <!-- </div> -->

    </div>

    <!-- <div class="col-sm-12" style="margin-top: 8px;">
    <div class=" col-sm-12 lefticonD paddingless" style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
        <label>{{TypeHeader}} </label>
    </div>

    <br>

</div> -->


    <div><br>&nbsp;</div>
    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>
    <div class="jumbotron p-4">
        <div class="container text-center col-sm-4 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div>


</my-content>
<my-content placeholder="main">

</my-content>
